export default __webpack_public_path__ + "static/media/login-video.29a3d251.mp4";